import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslationService } from './translation.service';

/**
 * Titulo de la pestaña del navegador, resuelto contra el bundle.
 *
 * Angular aplica el `title` de la ruta tal cual, de modo que una ruta que lo
 * declara como clave (`OPTIONS_EXCHANGE_RATE`) terminaba mostrando el
 * identificador crudo en la pestaña. Aqui se traduce antes de aplicarlo.
 *
 * Las rutas que declaran el titulo como texto siguen viendose igual: cuando la
 * clave no esta en el bundle, {@link TranslationService.translate} devuelve lo
 * que recibio. Por eso convivir con las dos formas no rompe nada.
 *
 * El titulo se vuelve a aplicar al cambiar de idioma, sin esperar a que el
 * usuario navegue.
 */
@Injectable({ providedIn: 'root' })
export class NebulaTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translation = inject(TranslationService);

  /** Marca de la aplicacion con la que termina el titulo. */
  private static readonly BASE = 'Nebula ERP';

  /** Ultimo titulo declarado por la ruta activa, para poder retraducirlo. */
  private declarado: string | undefined;

  constructor() {
    super();
    this.translation.currentLang$.subscribe(() => this.aplicar());
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.declarado = this.buildTitle(snapshot);
    this.aplicar();
  }

  private aplicar(): void {
    const base = NebulaTitleStrategy.BASE;
    if (!this.declarado) {
      this.title.setTitle(base);
      return;
    }
    this.title.setTitle(`${this.translation.translate(this.declarado)} - ${base}`);
  }
}
